<template>
    <div>
        <section v-if="!participacoes || participacoes.length === 0" class="col s12">
            <div class="row">
                <div class="col s12 blue-grey lighten-5">
                    <p>
                        <i class="material-icons yellow-text text-darken-3 left">warning</i>
                        <span style="font-weight: bold;">Aviso!</span>
                        <span> O usuário não tem participações na SIAC. </span>
                    </p>
                </div>
            </div>
        </section>

        <section class="col s12" v-else>
            <ul class="collection">
                <li class="collection-item"
                    v-for="(participacao, participacao_i) in mostraParticipacoesNaSiac"
                    :key="participacao_i">
                    <i class="fa-solid fa-clipboard-list left"></i>
                    <span class="title">{{ participacao }}</span>

                </li>

            </ul>
        </section>

        <section class="col s12" v-if="analiseTecnica">
            <ul class="collection">
                <li class="collection-item" style="border: 2px solid #8c9eff">
                    <i class="fa-solid fa-list-check left"></i>
                    <span class="title" style="font-weight: bold;">Resultado da Análise Técnica: </span>
                    <span class="right">{{ analiseTecnica.item_participacoes_na_siac_pontuacao }} ponto(s)</span>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {
    name: "participacoes_na_siac",
    props: {
        participacoesNaSiac: {
            type: Array,
            default: () => { return [] }
        },
        pAnaliseTecnica: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            analiseTecnica: this.pAnaliseTecnica,
            participacoes: this.participacoesNaSiac,
        }
    },
    watch: {
        participacoesNaSiac: {
            deep: true,
            handler(newValue){
                this.participacoes = newValue
            }
        },
        participacoes: {
            deep: true,
            handler(newValue){
                this.$emit('update:participacoesNaSiac', newValue)
            }
        },
    },
    computed: {
        mostraParticipacoesNaSiac() {
            return _.map(this.participacoes, (partipacao) => {
                return _.upperCase(partipacao[1])
            })
        }
    },
}
</script>

<style scoped>

</style>
